exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3NjWI {\n    display: inline-block;\n    margin-right: 12px;\n}\n._1mavW {\n    text-align: right;\n    margin-top: 28px;\n}\n.KojO6 {\n    font-size: 18px;\n    color: #39483A;\n}\n._2wswr{\n    vertical-align: middle;\n    display: inline-block;\n}\n@media screen and (max-width: 1200px) {\n    ._1mavW {\n        text-align: center;\n    }\n    ._3NjWI {\n        display: block;\n        margin-right: 0px;\n        margin-bottom: 24px;\n    }\n    ._267vT {\n        padding: 12px 15px !important;\n    }\n}", ""]);

// exports
exports.locals = {
	"verifyBtn": "_3NjWI",
	"textVrify": "_1mavW",
	"labelColor": "KojO6",
	"vtrMiddle": "_2wswr",
	"btnPadding": "_267vT"
};